import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
    setPunchOutCartActive,
    setPunchOutSessionId,
    setPunchOutSessionInProgress,
    setPunchOutTab,
} from "redux/actions/punchOutActions";
import { getCarts } from "services/cart/cartAPIs";
import {
    cancelPunchOutSession,
    initiatePunchOutSession,
} from "services/punchout/punchoutAPIs";

import SignalRUserScopeSubscriber from "../../services/monitoring/signalRUserScopeSubscriber";
import { getImg } from "../../services/search/searchAPIs";
import noImage from "./../../assets/noImage.png";

const PunchOutSupplier = ({ supplier }) => {
    // Collect states and state dispatchers
    const dispatch = useDispatch();
    const activeOU = useSelector((state) => state.auth.activeOU);
    const userName = useSelector((state) => state.auth.samAccountName);
    const punchOutTab = useSelector((state) => state.punchOut.punchOutTab);
    const sessionId = useSelector((state) => state.punchOut.punchOutSessionId);
    const [imgUrl, setImgUrl] = useState(noImage);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getImg(supplier.ITEM_IMAGE_URL, setImgUrl);
    }, [supplier]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (punchOutTab && punchOutTab.closed) {
                //the punchOutTab has been closed either by the user or automatically by the Django app
                dispatch(setPunchOutTab(null));
                dispatch(setPunchOutSessionInProgress(false));

                //calling cancel in case the browser was closed before the session was finished successfully
                cancelPunchOutSession(sessionId, dispatch);
                clearInterval(interval);
            }
        }, 5000); // Check 5 every seconds

        return () => clearInterval(interval);
    }, [punchOutTab, dispatch]);

    const handlePunchOutSessionFinish = (data) => {
        if (data.processed === true) {
            setIsSubscribed(false);

            //refresh carts to ensure we see the punchout session results
            getCarts(dispatch);

            dispatch(setPunchOutTab(null)); // Clear the reference as the Django app will close its browser tab automatically
            dispatch(setPunchOutSessionInProgress(false));

            const wescoCartId = data.cartId;

            // Move to the cart page and load the WESCO cart
            if (wescoCartId) {
                dispatch(setPunchOutCartActive(true)); //this ensures that the cart is cleared when the requisition is processed
                navigate(`/cart/${wescoCartId}`);
            }
        }
    };

    // Function to handle button click
    const handleButtonClick = async (supplierName) => {
        // Call Url of initiate session route with supplierName as payload
        let response = [];
        response = await initiatePunchOutSession(
            supplierName,
            userName,
            activeOU,
            dispatch
        );

        // Render SignalRSubscriber before opening the new window
        setIsSubscribed(true);

        // Get payload of response from route
        // Open window with url from payload and target blank
        const newTab = window.open(response.redirect_url, "_blank");
        dispatch(setPunchOutTab(newTab));
        dispatch(setPunchOutSessionId(response.sessionId));
        dispatch(setPunchOutSessionInProgress(true));
    };

    return (
        <Card>
            {isSubscribed && (
                <SignalRUserScopeSubscriber
                    eventName="punchout_session_alert"
                    callback={handlePunchOutSessionFinish}
                />
            )}
            <CardMedia
                alt={supplier.supplierName}
                component="img"
                src={imgUrl}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = noImage;
                }}
                style={{
                    width: 180,
                    height: 180,
                    objectFit: "cover",
                    margin: "auto",
                }}
            />
            <CardContent>
                <Typography variant="h5" component="div">
                    {supplier.supplierName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {supplier.description}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleButtonClick(supplier.supplierName)}
                    sx={{ marginTop: 2 }}
                >
                    Punch out
                </Button>
            </CardContent>
        </Card>
    );
};

export default PunchOutSupplier;
